import axios from "axios";

//const API = axios.create({ baseURL: "http://localhost:5001", withCredentials: true });
const API = axios.create({ baseURL: "https://api.themaingategroup.com", withCredentials: true });

export const getCatalogList = (catalogName, start, length, token) => API.post("/admin/getcataloglist", { catalogName, start, length, token });
export const updateCatalogItem = (catalogName, item, token) => API.post("/admin/updatecatalogitem", { catalogName, item, token });
